import _ from "lodash";
import AppDispatcher from "../Dispatcher";
import EventEmitter from "events";
import { AppActionConstants } from "../Actions/AppActionConstants";

class AdSetDataStore extends EventEmitter {
	constructor() {
		super();

		this.adset = {
			data: [],
			config: [],
			errors: [],
			filteredData: []
		};

		/*
        Need to register all actions with the AppDispatcher
        */

		AppDispatcher.register((action) => {
			switch (action.type) {
				case AppActionConstants.fetchAdSet:
					const hierarchyData = action.value.data;
					hierarchyData.forEach((dataField) => {
						if (dataField.TaxonomyData) {
							JSON.parse(dataField.TaxonomyData).forEach((dataTaxonomyField) => {
								if (dataField[dataTaxonomyField.DataKeyShortDescr.split(" ").join("")]) {
									action.value.config.TaxonomyData.forEach((configTaxonomyField) => {
										if (
											configTaxonomyField.ID === dataTaxonomyField.DataKeyID &&
											configTaxonomyField.Name !== dataTaxonomyField.DataKeyShortDescr.split(" ").join("")
										) {
											dataField[configTaxonomyField.Name] = dataField[dataTaxonomyField.DataKeyShortDescr.split(" ").join("")];
										}
									});
								}
							});
						}
						if (dataField.MetaData) {
							JSON.parse(dataField.MetaData).forEach((dataMetaDataField) => {
								if (dataField[dataMetaDataField.DataKeyShortDescr.split(" ").join("")]) {
									action.value.config.MetaData.forEach((configMetaDataField) => {
										if (
											configMetaDataField.ID === dataMetaDataField.DataKeyID &&
											configMetaDataField.Name !== dataMetaDataField.DataKeyShortDescr.split(" ").join("")
										) {
											dataField[configMetaDataField.Name] = dataField[dataMetaDataField.DataKeyShortDescr.split(" ").join("")];
										}
									});
								}
							});
						}
					});
					this.adset.config = action.value.config;
					this.adset.data = hierarchyData;
					this.emit("adsets_loaded");
					break;
				case AppActionConstants.updateAdSetSuccess:
					this.adset.data = [...this.adset.data, action.value];
					this.emit("adsets_success");
					break;
				case AppActionConstants.updateAdSetFail:
					const errorObject = {};
					if (action.value.InputErrors) {
						action.value.InputErrors.forEach((error) => {
							Object.keys(error).forEach((errorName) => {
								errorObject[errorName] = error[errorName];
							});
						});
					}
					if (action.value.Errors) {
						errorObject.Errors = [action.value.Errors];
					}
					this.adset.errors = errorObject;
					this.emit("adsets_fail");
					break;
				case AppActionConstants.editAdSetSuccess:
					this.adset.data.splice(action.row, 1, action.value);
					this.adset.data = [...this.adset.data];
					this.emit("adsets_edit_success");
					break;
				case AppActionConstants.editAdSetFail:
					const editErrorObject = {};
					if (action.value.InputErrors) {
						action.value.InputErrors.forEach((error) => {
							Object.keys(error).forEach((errorName) => {
								editErrorObject[errorName] = error[errorName];
							});
						});
					}
					if (action.value.Errors) {
						editErrorObject.Errors = [action.value.Errors];
					}
					this.adset.errors = editErrorObject;
					this.emit("adsets_edit_fail");
					break;
				case AppActionConstants.createAndAddAdSetSuccess:
					this.adset.data = [...this.adset.data, action.value];
					this.emit("create_and_add_adsets_success");
					break;
				case AppActionConstants.deleteAdSet:
					this.adset.data = this.adset.data.filter((adset) => {
						return !action.value.includes(adset.AdSetID);
					});
					if (this.adset.filteredData.length !== 0) {
						const filteredData = JSON.parse(JSON.stringify(this.adset.filteredData));
						this.adset.filteredData = filteredData.filter((filteredAdSet) => {
							return !action.value.includes(filteredAdSet.AdSetID);
						});
					}
					this.emit("adset_deleted");
					break;
				case AppActionConstants.duplicateAdSet:
					this.emit("duplicate_adset_success");
					break;
				case AppActionConstants.duplicateAdSetFail:
					this.emit("duplicate_adset_fail");
					break;
				case AppActionConstants.setFilteredAdSets:
					this.adset.filteredData = action.value;
					this.emit("filteredData");
					break;
				default:
					break;
			}
		});
	}

	/*
    Getter function to return the current state
    */
	getData = () => this.adset.data;
	getFilteredData = () => this.adset.filteredData;
	getConfig = () => this.adset.config;
	getErrors = () => this.adset.errors;

	resetAdSetErrors = () => {
		this.adset.errors = [];
		this.emit("adset__errors__reset");
	};

	resetAdSetData = () => {
		this.adset.config = [];
	};

	returnDataRow = (row) => {
		return this.adset.data[row];
	};

	returnFilteredDataRow = (row) => {
		return this.adset.filteredData[row];
	};

	updateDataManually = (data, bundle) => {
		for (const key in bundle) {
			if (bundle[key].Result === true) {
				const newRow = this.getFilteredData().length !== 0 ? this.returnFilteredDataRow(key) : this.returnDataRow(key);
				if (newRow) {
					newRow.AdSetName = bundle[`${key}`].Object.AdSetName;
					newRow.UniqueID = bundle[`${key}`].Object.UniqueID;
					if (bundle[`${key}`].Object.ParentUniqueIDCode) {
						newRow.ParentUniqueIDCode = bundle[`${key}`].Object.ParentUniqueIDCode;
					}
					newRow.AdSetID = bundle[`${key}`].Object.AdSetID;
				} else {
					const existingRow = data.filter((lineItem) => lineItem.UniqueID === key);
					if (existingRow[0]) {
						existingRow[0].UniqueID = bundle[`${key}`].Object.UniqueID;
						existingRow[0].AdSetName = bundle[`${key}`].Object.AdSetName;
					}
				}
			}
		}
	};

	updateExistingValues = (data, config) => {
		const newData = data;
		const fieldNames = {};
		const fieldIds = {};
		const excludedFieldNames = ["CampaignID", "UniqueID", "TaxonomyData", "MetaData", "AdSetName", "AdSetID", "IsArchived", "IsDeleted", "UpdatedBy"];
		config.TaxonomyData.forEach((taxonomyField) => {
			fieldNames[taxonomyField.Name] = taxonomyField.ID;
			fieldIds[taxonomyField.ID] = taxonomyField.Name;
		});
		config.MetaData.forEach((metadataField) => {
			fieldNames[metadataField.Name] = metadataField.ID;
			fieldIds[metadataField.ID] = metadataField.Name;
		});
		config.AdSetData.forEach((placementField) => {
			fieldNames[placementField.Name] = placementField.ID;
			fieldIds[placementField.ID] = placementField.Name;
		});
		newData.forEach((dataField) => {
			if (!_.isEmpty(dataField)) {
				Object.keys(dataField).forEach((dataKeyName) => {
					if (!excludedFieldNames.includes(dataKeyName) && !Object.keys(fieldNames).includes(dataKeyName)) {
						let matchingId = null;
						if (dataField.TaxonomyData !== "") {
							JSON.parse(dataField.TaxonomyData).forEach((dataTaxonomyField) => {
								if (matchingId !== null) {
									return;
								}
								if (dataTaxonomyField.DataKeyShortDescr.split(" ").join("") === dataKeyName) {
									matchingId = dataTaxonomyField.DataKeyID;
								}
							});
						}
						if (matchingId === null) {
							if (dataField.MetaData !== "") {
								JSON.parse(dataField.MetaData).forEach((dataMetaDataField) => {
									if (matchingId !== null) {
										return;
									}
									if (dataMetaDataField.DataKeyShortDescr.split(" ").join("") === dataKeyName) {
										matchingId = dataMetaDataField.DataKeyID;
									}
								});
							}
						}
						if (matchingId !== null) {
							if (fieldIds[matchingId]) {
								dataField[fieldIds[matchingId]] = dataField[dataKeyName];
							}
						}
					}
				});
			}
		});
		return newData;
	};
}

export default new AdSetDataStore();
